import React from 'react';

export type AuthMessageVariant = 'error' | 'success' | 'info';

interface AuthMessageProps {
  variant: AuthMessageVariant;
  children: React.ReactNode;
  className?: string;
}

const AuthMessage: React.FC<AuthMessageProps> = ({ variant, children, className }) => (
  <div
    className={`auth-message auth-message--${variant}${className ? ` ${className}` : ''}`}
    role={variant === 'info' ? 'status' : 'alert'}
  >
    {children}
  </div>
);

export default AuthMessage;
